import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireStorage } from '@angular/fire/compat/storage';

import { Observable, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class StorageService {

  constructor(
    private http: HttpClient,
    private storage: AngularFireStorage
  ) { }

  // On upload the file
  public upload(path: string, file: any): Observable<number> {
    return this.storage.upload(path, file).percentageChanges().pipe(map(v => v ?? 0));
  }

  // On download the file
  public download(path: string): Observable<any> {
    return this.storage.ref(path).getDownloadURL();
  }

  // On download to blob
  public async getToBlob(path: string): Promise<Blob> {
    return fetch(await firstValueFrom(this.storage.ref(path).getDownloadURL()) as string).then(ret => ret.blob());
  }
}
